import { render, staticRenderFns } from "./TeacherCreate.vue?vue&type=template&id=3282813b&scoped=true&"
import script from "./TeacherCreate.vue?vue&type=script&lang=js&"
export * from "./TeacherCreate.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCreate.vue?vue&type=style&index=0&id=3282813b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282813b",
  null
  
)

export default component.exports